import { __awaiter } from "tslib";
import { useState } from 'react';
import i18n from 'i18next';
import { useCheckFfpStatusQuery } from '@websky/graphql';
import { useConfig } from '../../../../context';
const useFfpStatusCheck = () => {
    const { checkFfpStatus: isEnabled } = useConfig().Engine;
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const { refetch: fetchFfpStatusCheck } = useCheckFfpStatusQuery({ skip: true });
    const checkFfpStatus = (travellers) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        if (!travellers.length) {
            return null;
        }
        setIsLoading(true);
        try {
            const { data } = yield fetchFfpStatusCheck({ params: travellers });
            setIsLoading(false);
            if ((_a = data === null || data === void 0 ? void 0 : data.CheckFfpStatus) === null || _a === void 0 ? void 0 : _a.some(result => !result.success)) {
                const errors = {};
                data.CheckFfpStatus.forEach(result => {
                    if (!result.success) {
                        errors[result.travellerId] = i18n.t(result.errorMsg, {
                            ns: 'Passenger',
                            nsSeparator: '|',
                            keySeparator: '>'
                        });
                    }
                });
                if (travellers.length === 1) {
                    setError((_b = errors[travellers[0].travellerId]) !== null && _b !== void 0 ? _b : Object.values(errors)[0]);
                }
                return errors;
            }
            setError(null);
            return null;
        }
        catch (e) {
            setIsLoading(false);
            throw e;
        }
    });
    return { checkFfpStatus, isLoading, isEnabled, error };
};
export default useFfpStatusCheck;
